import type {
  _FolderWithCount,
  _TagWithCount,
  Folder,
  TagWithCount,
} from '@geartracker/types';

export const transformTagWithCount = (tag: _TagWithCount): TagWithCount => {
  return {
    id: tag.id,
    name: tag.name,
    category: tag.category,
    equipmentsCount: tag._count.equipments,
    usersCount: tag._count.users,
  };
};

export const transformFolderWithCount = (folder: _FolderWithCount): Folder => {
  return {
    createdAt: folder.createdAt,
    updatedAt: folder.updatedAt,
    depth: folder.depth,
    path: folder.path,
    parentId: folder.parentId,
    children: folder.children,
    id: folder.id,
    name: folder.name,
    description: folder.description,
    files: folder.files,
    isAccessibleByOrganization: folder.isAccessibleByOrganization,
    organizationId: folder.organizationId,
    users: folder.users,
    equipmentsCount: folder._count.Equipment,
    accessible: folder.accessible,
  };
};
